"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

export const PRIMARY_NAV = [
  { href: "/", label: "Browse" },
  { href: "/favorites", label: "Favorites" },
  { href: "/popular", label: "Popular" },
  { href: "/community-tags", label: "Community tags" },
] as const;

export function isNavActive(pathname: string, href: string): boolean {
  if (href === "/") return pathname === "/" || pathname.startsWith("/essences");
  return pathname === href || pathname.startsWith(`${href}/`);
}

export function NavLinks({ className }: { className?: string }) {
  const pathname = usePathname();

  return (
    <nav aria-label="Primary" className={cn("items-center gap-1", className)}>
      {PRIMARY_NAV.map((item) => {
        const active = isNavActive(pathname, item.href);
        return (
          <Link
            key={item.href}
            href={item.href}
            aria-current={active ? "page" : undefined}
            className={cn(
              "relative rounded-md px-3 py-1.5 text-[13.5px] font-medium transition-colors duration-150",
              "focus-visible:outline-2 focus-visible:outline-accent",
              active ? "text-ink" : "text-ink-3 hover:text-ink-2"
            )}
          >
            {item.label}
            <span
              aria-hidden
              className={cn(
                "absolute inset-x-3 -bottom-[15px] h-px rounded-full bg-accent transition-opacity duration-200",
                active ? "opacity-100 shadow-[0_0_10px_rgb(167_139_250/0.8)]" : "opacity-0"
              )}
            />
          </Link>
        );
      })}
    </nav>
  );
}
